"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sb tooltip
 *
 * Data attributes
 * data-p-trigger - trigger event 'click', 'hover', 'click_hover' , default: 'click_hover'
 * data-p-title - tooltip title text
 * data-p-content - tooltip content text
 * data-p-image - tooltip image content
 * data-p-video - tooltip video content
 * data-p-more-link - tooltip more info link
 * data-p-more-title - tooltip more info button title
 * data-p-popper-id - tooltip block id, for example #some_popper or .some_popper
 * data-p-placement - enum: auto, top, right, bottom, left. Each placement can have a variation from this list:  -start -end.  Default: auto
 *
 */
var __SbTooltipObjects = {};
var __SbTooltipOptions = {};
var __SbTooltipNodes = {};

var SbTooltipCommon = function SbTooltipCommon(options) {
  _classCallCheck(this, SbTooltipCommon);

  this._loadJs = function (u, c, nonce) {
    var d = document,
        t = 'script',
        o = d.createElement(t),
        s = d.getElementsByTagName(t)[0]; //o.src = '//' + u;

    o.src = u; //console.log('nonce : ' + nonce);

    if (nonce) {
      o.setAttribute('nonce', nonce);
    }

    if (c) {
      o.addEventListener('load', function (e) {
        c(null, e);
      }, false);
    }

    s.parentNode.insertBefore(o, s);
  };

  this._getUniqueId = function () {
    return 'sbt_' + (new Date().getUTCMilliseconds().toString() + new Date().getTime().toString()).toString();
  };
};

var SbTooltip =
/*#__PURE__*/
function (_SbTooltipCommon) {
  _inherits(SbTooltip, _SbTooltipCommon);

  function SbTooltip(_options) {
    var _this2;

    _classCallCheck(this, SbTooltip);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SbTooltip).call(this, _options));
    Object.defineProperty(_assertThisInitialized(_this2), _isPopperLoaded, {
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this2), _popperSrc, {
      writable: true,
      value: "/v2/lib/popper/popper.min.js"
    });
    Object.defineProperty(_assertThisInitialized(_this2), _defaultElementOptions, {
      writable: true,
      value: {
        trigger: 'click_hover',
        title: '',
        content: '',
        image: null,
        video: null,
        moreLink: null,
        moreTitle: 'read more',
        popperId: null,
        placement: 'auto',
        contentPolicyNonce: null
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _videoFormats, {
      writable: true,
      value: {
        ogg: 'video/ogg; codecs="theora"',
        h264: 'video/mp4; codecs="avc1.42E01E"',
        webm: 'video/webm; codecs="vp8, vorbis"',
        vp9: 'video/webm; codecs="vp9"',
        hls: 'application/x-mpegURL; codecs="avc1.42E01E"'
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getDataAsObject, {
      writable: true,
      value: function value($node) {
        var data = $node.data();
        var res = {};

        for (var key in data) {
          if (key && data.hasOwnProperty(key) && String(key).indexOf('p') === 0) {
            var kkey = String(key).replace('p', '');
            kkey = kkey.charAt(0).toLowerCase() + kkey.slice(1);
            res[kkey] = data[key];
          }
        }

        return res;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _showPopper, {
      writable: true,
      value: function value() {
        var _this = _assertThisInitialized(_this2); //Hover


        jQuery(document).on('mouseover', '.sb-tooltip', function (event) {
          _classPrivateFieldLooseBase(_this, _onShowEvent)[_onShowEvent](jQuery(this), 'hover');
        });
        jQuery(document).on('mouseleave', '.sb-tooltip', function (event) {
          _classPrivateFieldLooseBase(_this, _onHideEvent)[_onHideEvent](jQuery(this), 'hover');
        }); //click

        jQuery(window).click(function () {
          //console.log('click outside');
          _classPrivateFieldLooseBase(_this, _onHideEvent)[_onHideEvent](jQuery(this), 'click');
        });
        jQuery(document).on('click', '.sb-tooltip', function (event) {
          _classPrivateFieldLooseBase(_this, _onShowEvent)[_onShowEvent](jQuery(this), 'click');

          event.stopPropagation();
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onHideEvent, {
      writable: true,
      value: function value($node, eventType) {
        var _this = _assertThisInitialized(_this2);

        jQuery.each(__SbTooltipNodes, function (id, $popper) {
          var options = __SbTooltipOptions[id]; //console.log(_this.#_isNodePopperVisible($popper, options), $popper);

          if ($popper.is(':visible')) {
            var lastEvent = $popper.data('p-load-event');

            if (lastEvent && lastEvent === eventType) {
              _classPrivateFieldLooseBase(_this, _hidePopper)[_hidePopper]($popper, eventType, options); //console.log('hide');

            }
          }
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _onShowEvent, {
      writable: true,
      value: function value($node, eventType) {
        var options = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getDataAsObject)[_getDataAsObject]($node);

        options = jQuery.extend({}, _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _defaultElementOptions)[_defaultElementOptions], options);

        if (options.trigger === 'click_hover' && ['hover', 'click'].includes(eventType)) {
          var isNodeVisible = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _isNodePopperVisible)[_isNodePopperVisible]($node, options);

          if (!isNodeVisible || eventType === 'click') {
            //if node not visible or if visible by hover
            var cnodeId = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _showPopperForNode)[_showPopperForNode]($node, options);

            __SbTooltipNodes[cnodeId].data('p-load-event', eventType); //console.log('show');

          }
        }

        if (options && options.trigger === eventType) {
          var _cnodeId = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _showPopperForNode)[_showPopperForNode]($node, options);

          __SbTooltipNodes[_cnodeId].data('p-load-event', eventType); //console.log('show');

        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _showPopperForNode, {
      writable: true,
      value: function value($cnode, options) {
        var cnodeId = $cnode.attr('id');

        if (!cnodeId) {
          cnodeId = _this2._getUniqueId();
          $cnode.attr('id', cnodeId);
        }

        if (!__SbTooltipObjects[cnodeId]) {
          var $popperNode = null;

          if (options.popperId) {
            $popperNode = jQuery('#' + options.popperId);
          }

          if (!$popperNode || !$popperNode.length) {
            $popperNode = jQuery('#' + cnodeId + '_popper');
          }

          if (!$popperNode || !$popperNode.length) {
            $popperNode = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _createPopperNode)[_createPopperNode](options);
            $popperNode.hide().attr('id', cnodeId + '_popper').insertAfter($cnode);
          }

          __SbTooltipOptions[cnodeId] = options;
          __SbTooltipNodes[cnodeId] = $popperNode;
          __SbTooltipObjects[cnodeId] = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _newPopper)[_newPopper]($cnode, $popperNode, options);
        } else {
          __SbTooltipObjects[cnodeId].scheduleUpdate();
        }

        __SbTooltipNodes[cnodeId].show();

        new SbTooltipYoutubeHelper(options).playAllVideo(__SbTooltipNodes[cnodeId]);
        new SbTooltipVimeoHelper(options).playAllVideo(__SbTooltipNodes[cnodeId]);

        _this2.onShowPopper($cnode, cnodeId);

        return cnodeId;
      }
    });

    _this2.onShowPopper = function ($node, nodeId) {
      jQuery($node).trigger('sb-popper-show', [nodeId, _assertThisInitialized(_this2)]);
    };

    _this2.onHidePopper = function ($node, nodeId) {
      jQuery($node).trigger('sb-popper-hide', [nodeId, _assertThisInitialized(_this2)]);
    };

    Object.defineProperty(_assertThisInitialized(_this2), _isNodePopperVisible, {
      writable: true,
      value: function value($node, options) {
        var cnodeId = $node.attr('id');

        if (!cnodeId) {
          return false;
        }

        var $popperNode = null;

        if (options.popperId) {
          $popperNode = jQuery(options.popperId);
        }

        if (!$popperNode || !$popperNode.length) {
          $popperNode = jQuery('#' + cnodeId + '_popper');
        }

        if (!$popperNode || !$popperNode.length) {
          return false;
        }

        return $popperNode.is(':visible');
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _newPopper, {
      writable: true,
      value: function value($cnode, $popperNode, options) {
        var popperOptions = {
          placement: options.placement
        };
        return new Popper($cnode, $popperNode, popperOptions);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _hideAllPoppers, {
      writable: true,
      value: function value(eventType) {
        var _this = _assertThisInitialized(_this2);

        jQuery.each(__SbTooltipNodes, function (id, $popper) {
          var cPOptions = __SbTooltipOptions[id];

          _classPrivateFieldLooseBase(_this, _hidePopper)[_hidePopper]($popper, eventType, cPOptions);

          _this.onHidePopper(jQuery('#' + id), id);
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _hidePopper, {
      writable: true,
      value: function value($node, eventType, options) {
        if ($node && options) {
          if (options.trigger === eventType || options.trigger === 'click_hover' && ['hover', 'click'].includes(eventType)) {
            $node.hide();
            new SbTooltipYoutubeHelper(options).pauseAllVideos($node);
            new SbTooltipVimeoHelper(options).pauseAllVideos($node);
          }
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _createPopperNode, {
      writable: true,
      value: function value(options) {
        var $node = jQuery('<div class="popper-content"></div>');
        var $popperBody = jQuery('<div class="popper-body"></div>');
        $node.hide();

        if (options.image) {
          //console.log(options.image);
          // let $imageNode = jQuery('<div class="popper-image"></div>').css({
          //     'background-image' : "url(" + options.image + ")"
          // });
          var $imageNode = jQuery('<div class="popper-image"></div>').append('<img src="' + options.image + '" alt="">');
          $node.addClass('has-image');
          $popperBody.append($imageNode);
        }

        if (options.video) {
          var playerHtml = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getVideoPlayerHtml)[_getVideoPlayerHtml](options.video, $node);

          if (playerHtml && playerHtml !== '') {
            $node.addClass('has-video');
            $popperBody.append(jQuery('<div class="popper-video"></div>').append(playerHtml));
          }
        }

        if (options.title) {
          $popperBody.append('<span class="popper-title">' + options.title + '</span>');
          $node.addClass('has-title');
        }

        $popperBody.append('<span class="popper-text">' + options.content + '</span>');

        if (options.moreLink) {
          if (typeof Locale !== 'undefined') {
            options.moreTitle = Locale.get(options.moreTitle);
          }

          $node.addClass('has-more-link');
          $popperBody.append('<a class="popper-more-btn" href="' + options.moreLink + '">' + options.moreTitle + '</a>');
        }

        $popperBody.append(jQuery(' <div class="popper__arrow" x-arrow=""></div>'));
        $node.append($popperBody);
        return $node;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getVideoPlayerHtml, {
      writable: true,
      value: function value(url, $parentNode) {
        var youtubeHelper = new SbTooltipYoutubeHelper(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _defaultElementOptions)[_defaultElementOptions]);
        var vimeoHelper = new SbTooltipVimeoHelper(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _defaultElementOptions)[_defaultElementOptions]);
        var youtubeId = youtubeHelper.getYoutubeIdByUrl(url);
        var vimeoId = vimeoHelper.getVimeoIdByUrl(url);

        if (youtubeId) {
          return youtubeHelper.getYoutubePlayer(youtubeId, $parentNode);
        }

        if (vimeoId) {
          return vimeoHelper.getVimeoPlayer(vimeoId, $parentNode);
        }

        var videoType = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getVideoTypeByUrl)[_getVideoTypeByUrl](url);

        var videoSupported = videoType && _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _isSupportsVideoType)[_isSupportsVideoType](videoType);

        if (!videoType || !videoSupported) {
          console.warn('Current video not supported');
          return '';
        }

        return '<video><source src="' + url + '" type="' + _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _videoFormats)[_videoFormats][videoType] + '"></video>';
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _checkPopper, {
      writable: true,
      value: function value() {
        if (window.Popper) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _isPopperLoaded)[_isPopperLoaded] = true;
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _loadPopper, {
      writable: true,
      value: function value(popperReadyHandler) {
        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _isPopperLoaded)[_isPopperLoaded]) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _checkPopper)[_checkPopper]();
        }

        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _isPopperLoaded)[_isPopperLoaded]) {
          _this2._loadJs(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _popperSrc)[_popperSrc], function () {
            _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _isPopperLoaded)[_isPopperLoaded] = true;

            if (typeof popperReadyHandler === 'function') {
              popperReadyHandler();
            }
          }, _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _defaultElementOptions)[_defaultElementOptions].contentPolicyNonce);
        } else {
          if (typeof popperReadyHandler === 'function') {
            popperReadyHandler();
          }
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _isSupportsVideoType, {
      writable: true,
      value: function value(type) {
        var video;

        if (!video) {
          video = document.createElement('video');
        }

        return video.canPlayType(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _videoFormats)[_videoFormats][type] || type);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getVideoTypeByUrl, {
      writable: true,
      value: function value(url) {
        if (String(url).indexOf('.ogv') !== false) {
          return 'ogg';
        }

        if (String(url).indexOf('.mp4') !== false) {
          return 'ogg';
        }

        if (String(url).indexOf('.webm') !== false) {
          return 'webm';
        }

        if (String(url).indexOf('.webm9') !== false) {
          return 'vp9';
        }

        if (String(url).indexOf('.m3u') !== false || String(url).indexOf('.m3u8') !== false) {
          return 'vp9';
        }
      }
    });

    if (_options) {
      _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _defaultElementOptions)[_defaultElementOptions] = jQuery.extend({}, _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _defaultElementOptions)[_defaultElementOptions], _options);
    }

    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _loadPopper)[_loadPopper](function () {
      //popper ready
      _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _showPopper)[_showPopper](); //console.log('ready');

    });

    return _this2;
  }

  return SbTooltip;
}(SbTooltipCommon);

var _isPopperLoaded = _classPrivateFieldLooseKey("isPopperLoaded");

var _popperSrc = _classPrivateFieldLooseKey("popperSrc");

var _defaultElementOptions = _classPrivateFieldLooseKey("defaultElementOptions");

var _videoFormats = _classPrivateFieldLooseKey("_videoFormats");

var _getDataAsObject = _classPrivateFieldLooseKey("_getDataAsObject");

var _showPopper = _classPrivateFieldLooseKey("showPopper");

var _onHideEvent = _classPrivateFieldLooseKey("_onHideEvent");

var _onShowEvent = _classPrivateFieldLooseKey("_onShowEvent");

var _showPopperForNode = _classPrivateFieldLooseKey("_showPopperForNode");

var _isNodePopperVisible = _classPrivateFieldLooseKey("_isNodePopperVisible");

var _newPopper = _classPrivateFieldLooseKey("_newPopper");

var _hideAllPoppers = _classPrivateFieldLooseKey("_hideAllPoppers");

var _hidePopper = _classPrivateFieldLooseKey("_hidePopper");

var _createPopperNode = _classPrivateFieldLooseKey("_createPopperNode");

var _getVideoPlayerHtml = _classPrivateFieldLooseKey("_getVideoPlayerHtml");

var _checkPopper = _classPrivateFieldLooseKey("checkPopper");

var _loadPopper = _classPrivateFieldLooseKey("loadPopper");

var _isSupportsVideoType = _classPrivateFieldLooseKey("_isSupportsVideoType");

var _getVideoTypeByUrl = _classPrivateFieldLooseKey("_getVideoTypeByUrl");

var SbTooltipVimeoHelper =
/*#__PURE__*/
function (_SbTooltipCommon2) {
  _inherits(SbTooltipVimeoHelper, _SbTooltipCommon2);

  function SbTooltipVimeoHelper(_options2) {
    var _this3;

    _classCallCheck(this, SbTooltipVimeoHelper);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(SbTooltipVimeoHelper).call(this));
    Object.defineProperty(_assertThisInitialized(_this3), _defaultElementOptions2, {
      writable: true,
      value: {}
    });

    _this3.getVimeoIdByUrl = function (url) {
      if (url !== undefined || url !== '') {
        var regExp = /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
        var match = url.match(regExp);

        if (match && match[3]) {
          return match[3];
        }
      }

      return false;
    };

    _this3.getVimeoPlayer = function (vimeoId, $parenNode) {
      //return '<iframe class="popper-vimeo" src="https://player.vimeo.com/video/' + vimeoId + '" frameborder="0"  webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
      var playeId = _this3._getUniqueId() + '_vimeo';
      var $vimeoPlayer = jQuery("<div  class=\"popper-vimeo\" id='" + playeId + "'></div>");

      _this3._loadJs("https://player.vimeo.com/api/player.js", function () {
        var options = {
          id: vimeoId,
          loop: true,
          autoplay: true //width: "100%"

        };
        var player = new Vimeo.Player(playeId, options);
        player.on('play', function () {
          $vimeoPlayer.find('iframe').attr('width', '100%').attr('height', null);
        });
        player.play();

        if (!SbTooltipVimeoHelper.players) {
          SbTooltipVimeoHelper.players = {};
        }

        SbTooltipVimeoHelper.players[playeId] = player;
      }, _classPrivateFieldLooseBase(_assertThisInitialized(_this3), _defaultElementOptions2)[_defaultElementOptions2].contentPolicyNonce);

      return $vimeoPlayer;
    };

    Object.defineProperty(_assertThisInitialized(_this3), _sendFrameCommand, {
      writable: true,
      value: function value($parentNode, command) {
        var $vimeo = jQuery('.popper-vimeo', $parentNode);
        var videoId = null;

        if ($vimeo && $vimeo.length) {
          videoId = $vimeo.attr('id');
        }

        if (videoId && SbTooltipVimeoHelper && SbTooltipVimeoHelper.players) {
          var player = SbTooltipVimeoHelper.players[videoId];

          if (player) {
            player[command]();
          }
        } // jQuery('.popper-youtube', $parentNode).each(function(){
        //     if(this.contentWindow && this.contentWindow.postMessage) {
        //         this.contentWindow.postMessage(JSON.stringify({event: 'command', func: command}), '*');
        //     }
        // });

      }
    });

    _this3.playAllVideo = function ($parentNode) {
      //play all youtube videos in parentNode
      _classPrivateFieldLooseBase(_assertThisInitialized(_this3), _sendFrameCommand)[_sendFrameCommand]($parentNode, 'play');
    };

    _this3.pauseAllVideos = function ($parentNode) {
      //pause all youtube videos in parentNode
      _classPrivateFieldLooseBase(_assertThisInitialized(_this3), _sendFrameCommand)[_sendFrameCommand]($parentNode, 'pause');
    };

    _this3.stopAllVideos = function ($parentNode) {
      //stop all youtube videos in parentNode
      _classPrivateFieldLooseBase(_assertThisInitialized(_this3), _sendFrameCommand)[_sendFrameCommand]($parentNode, 'stop');
    };

    if (_options2) {
      _classPrivateFieldLooseBase(_assertThisInitialized(_this3), _defaultElementOptions2)[_defaultElementOptions2] = jQuery.extend({}, _classPrivateFieldLooseBase(_assertThisInitialized(_this3), _defaultElementOptions2)[_defaultElementOptions2], _options2);
    }

    return _this3;
  }

  return SbTooltipVimeoHelper;
}(SbTooltipCommon);

var _defaultElementOptions2 = _classPrivateFieldLooseKey("defaultElementOptions");

var _sendFrameCommand = _classPrivateFieldLooseKey("_sendFrameCommand");

var SbTooltipYoutubeHelper =
/*#__PURE__*/
function (_SbTooltipCommon3) {
  _inherits(SbTooltipYoutubeHelper, _SbTooltipCommon3);

  function SbTooltipYoutubeHelper(options) {
    var _this4;

    _classCallCheck(this, SbTooltipYoutubeHelper);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(SbTooltipYoutubeHelper).call(this));
    Object.defineProperty(_assertThisInitialized(_this4), _defaultElementOptions3, {
      writable: true,
      value: {}
    });

    _this4.getYoutubeIdByUrl = function (url) {
      if (url !== undefined || url !== '') {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[2].length === 11) {
          return match[2];
        }
      }

      return false;
    };

    _this4.getYoutubePlayer = function (youtubeId, $parentNode) {
      //return '<iframe class="popper-youtube" src="https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&controls=0&loop=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      var playeId = _this4._getUniqueId() + '_youtube';
      var $youtubePlayer = jQuery("<div  class=\"popper-youtube\" id='" + playeId + "'></div>");

      _this4._loadJs("https://www.youtube.com/iframe_api", function () {
        var runPlayer = function runPlayer() {
          var player = new YT.Player(playeId, {
            //height: '360',
            width: '100%',
            videoId: youtubeId,
            playerVars: {
              'controls': 1,
              'showinfo': 0,
              'rel': 0,
              'loop': 1
            },
            events: {
              'onReady': function onReady(event) {
                if ($parentNode.is(":visible")) {
                  event.target.playVideo();
                }
              },
              'onStateChange': function onStateChange(event) {
                if (event.data === YT.PlayerState.ENDED) {
                  player.playVideo();
                }
              }
            }
          });
        };

        if (YT && YT.Player) {
          runPlayer();
        } else {
          window.onYouTubeIframeAPIReady = function () {
            runPlayer();
          };
        }
      }, _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _defaultElementOptions3)[_defaultElementOptions3].contentPolicyNonce);

      return $youtubePlayer;
    };

    Object.defineProperty(_assertThisInitialized(_this4), _sendFrameCommand2, {
      writable: true,
      value: function value($parentNode, command) {
        jQuery('.popper-youtube', $parentNode).each(function () {
          if (this.contentWindow && this.contentWindow.postMessage) {
            try {
              this.contentWindow.postMessage(JSON.stringify({
                event: 'command',
                func: command
              }), '*');
            } catch (e) {
              console.log(e);
              var a = e; ///do not show error when window not ready
            }
          }
        });
      }
    });

    _this4.playAllVideo = function ($parentNode) {
      //play all youtube videos in parentNode
      _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _sendFrameCommand2)[_sendFrameCommand2]($parentNode, 'playVideo');
    };

    _this4.pauseAllVideos = function ($parentNode) {
      //pause all youtube videos in parentNode
      _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _sendFrameCommand2)[_sendFrameCommand2]($parentNode, 'pauseVideo');
    };

    _this4.stopAllVideos = function ($parentNode) {
      //stop all youtube videos in parentNode
      _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _sendFrameCommand2)[_sendFrameCommand2]($parentNode, 'stopVideo');
    };

    if (options) {
      _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _defaultElementOptions3)[_defaultElementOptions3] = jQuery.extend({}, _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _defaultElementOptions3)[_defaultElementOptions3], options);
    }

    return _this4;
  }

  return SbTooltipYoutubeHelper;
}(SbTooltipCommon);

var _defaultElementOptions3 = _classPrivateFieldLooseKey("defaultElementOptions");

var _sendFrameCommand2 = _classPrivateFieldLooseKey("_sendFrameCommand");
//# sourceMappingURL=simplybook.tooltip.js.map
